import styled from 'styled-components';
import {device} from 'styled/device';

export const ShareBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  path {
    fill: ${({theme}) =>
      theme.hasTemplate
        ? theme.colors.branding.primary
        : theme.colors.buttons.mainButtonBackground};
  }
  gap: 8px;
  @media (min-width: ${device.tablet}) {
    top: 24px;
  }
`;

export const ShareText = styled.div`
  color: ${({theme}) =>
    theme.hasTemplate
      ? theme.colors.branding.primary
      : theme.colors.buttons.mainButtonBackground};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
